import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import sv from './locales/swe/translations.json';
import da from './locales/da/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    sv: {
      translation: sv,
    },
    da: {
      translation: da,
    },
  },
  lng: 'sv',
  fallbackLng: 'sv',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
